import React, { createContext, useState, useContext, useEffect } from "react";
import { safeJsonParse } from "utils";

const DataContext = createContext();

export const useDataContext = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
  const [dataId, setDataId] = useState(() => {
    const sessionDataId = sessionStorage.getItem("dataId");
    return safeJsonParse(sessionDataId);
  });

  useEffect(() => {
    if (dataId !== null) {
      sessionStorage.setItem("dataId", JSON.stringify(dataId));
    } else {
      sessionStorage.removeItem("dataId");
    }
  }, [dataId]);
  return (
    <DataContext.Provider value={{ dataId, setDataId }}>
      {children}
    </DataContext.Provider>
  );
};
